import React from 'react'

import ControlButtonStandard from "../../../../core/gd-components/buttons/control-button/control-button-standard"

type Props = {
    className?      : string

    app?            : any
    hint?           : string
    domElementId?   : string     // used for tours
    iconOnly?       : boolean

    onClick?        : callback

    preferencesComponent?   : any   // Experimental not in user
}

const debug = false
// const debug = "AppControlPreferences"

export default function AppControlPreferences(props:Props) {

    const {hint = 'Preferences'} = props

    const onClick = () => {

        // experimental not in use
        if (props.preferencesComponent && props.app) {
            debug && console.log(debug, 'onClick component app name', gd.layout.right.component?.props?.app.name, props.app.name, gd.layout.right.component)

            if (gd.layout.right.component?.props?.app.name === props.app.name) {
                gd.layout.right.hide()
            } else {
                gd.layout.right.show(<props.preferencesComponent app={props.app} />)
            }
            return
        }

        if (props.onClick) props.onClick()
        else props.app?.showPreferences()
    }

    const classes = Classes('p-l-6 p-r-6 m-r-8', props.className)

    return (
        <ControlButtonStandard id           = {props.domElementId}
                               className    = {classes}
                               hint         = {hint}
                               onClick      = {onClick}>
            <div className="icon ui5-ico-14 i5-custom-fields"/>
            {!props.iconOnly &&
                <div className="label txt-truncate ui5-txt-not-important-small m-l-5">Preferences</div>}
        </ControlButtonStandard>
    )
}
